const teamMembers = [
  {
    name: "Mama Noureesh",
    role: "Founder & Head Chef",
    bio: "With 30+ years of culinary experience, Mama Noureesh personally oversees all our recipes to ensure authentic taste.",
    image: "https://images.unsplash.com/photo-1595476108010-b4d1f102b1b1"
  },
  {
    name: "Chef Carlox",
    role: "Operations Manager",
    bio: "Ensures every order meets our high standards and gets delivered fresh and on time.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a"
  },
  {
    name: "Chioma Okeke",
    role: "Pastry Chef",
    bio: "Specializes in our signature cakes and desserts, trained in Paris and Lagos.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2"
  }
];

export default teamMembers;